import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { findLanguage } from '@ff-os/shared-translations/localization';
import { PdpState } from '../store';

export const displayModes = ['window', 'inline'] as const;
export const languages = ['en-US', 'fr-BE', 'nl-NL', 'de-DE'] as const;

export type GlobalState = {
    language: typeof languages[number];
    displayMode: typeof displayModes[number];
};

export type Language = GlobalState['language'];
export type DisplayMode = GlobalState['displayMode'];

export const defaultLanguage = 'nl-NL';
export const defaultDisplayMode = 'inline';

export const { actions, reducer } = createSlice({

    name: 'global',

    initialState: {
        language: defaultLanguage,
        displayMode: defaultDisplayMode
    } as GlobalState,

    reducers: {

        setLanguage: (state, action: PayloadAction<Language>) => {

            const language = findLanguage(languages, action.payload);

            if (!language) {
                return state;
            }

            return {
                ...state,
                language: language
            };
        },
        setDisplayMode: (state, action: PayloadAction<DisplayMode>) => {

            if (!displayModes.includes(action.payload)) {
                return state;
            }

            return {
                ...state,
                displayMode: action.payload
            };
        }
    }
});

export const selectLanguage = createSelector([
    (state: PdpState) => state
], state => state.global.language);

export const selectDisplayMode = createSelector([
    (state: PdpState) => state
], state => state.global.displayMode);

export const selectIsWindowMode = createSelector([
    selectDisplayMode
], (mode) => mode === 'window');